module.exports = __webpack_public_path__ + "img/Chat-app.ab0dec77.png";